"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulerTemplateManager = void 0;
var RulerTemplateManager = (function () {
    function RulerTemplateManager() {
    }
    RulerTemplateManager.getLeftIndentTopElementTemplate = function () { return null; };
    RulerTemplateManager.getLeftIndentBodyElementTemplate = function () { return null; };
    RulerTemplateManager.getRightIndentElementTemplate = function () { return null; };
    RulerTemplateManager.getFirstLineIndentElementTemplate = function () { return null; };
    RulerTemplateManager.getLeftTabElementTemplate = function () { return null; };
    RulerTemplateManager.getCenterTabElementTemplate = function () { return null; };
    RulerTemplateManager.getRightTabElementTemplate = function () { return null; };
    RulerTemplateManager.getDecimalTabElementTemplate = function () { return null; };
    RulerTemplateManager.getTableColumnDragElementTemplate = function () { return null; };
    return RulerTemplateManager;
}());
exports.RulerTemplateManager = RulerTemplateManager;
